export const DEFAULT_INSTREAM_DURATION: number = 30 as const // [s]
export const DEFAULT_VAST_URL: string =
  'https://s2s.yieldbird.com/pbc/cache?uuid=%%PATTERN:hb_uuid%%' as const
